// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".teachingstatistics-classstatucs-table .t_linkName[data-v-11aa949d]{color:#409eff;cursor:pointer;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}", ""]);
// Exports
module.exports = exports;
